import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { ExcludedUrlRegex } from './authentication';

@Injectable()
export class KeycloakTokenInterceptor implements HttpInterceptor {
    private authentication = inject(AuthenticationService);

    private isUrlExcluded({ method, url }: HttpRequest<any>, { urlPattern, httpMethods }: ExcludedUrlRegex): boolean {
        if (!httpMethods) {
            httpMethods = [];
        }
        const httpTest = httpMethods.length === 0 || httpMethods.join().indexOf(method.toUpperCase()) > -1;
        const urlTest = urlPattern.test(url);
        return httpTest && urlTest;
    }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // TODO: Remove conditional early return as the interceptor should always be enabled.
        // if (!this.authentication.enableBearerInterceptor) {
        //     return next.handle(request);
        // }
        if (!this.authentication.initialized()) {
            return next.handle(request);
        }

        const pass: boolean = (this.authentication.excludedUrls || []).findIndex(url => this.isUrlExcluded(request, url)) > -1;

        if (pass) {
            return next.handle(request);
        }

        return this.authentication.addTokenToHeader(request.headers).pipe(
            mergeMap(newHeaders => {
                const keycloakRequest = request.clone({ headers: newHeaders });
                return next.handle(keycloakRequest);
            })
        );
    }
}
